import {useOutletContext, useNavigate} from "react-router";
import {useState, useCallback, useEffect} from "react";
import Grid from "@mui/material/Grid2";
import {MeasurePanel} from "../components/MeasurePanel";
import {ProfitDriversPanel} from "../components/ProfitDriversPanel";
import {ProfitLeaksPanel} from "../components/ProfitLeaksPanel";
import {AlertsPanel} from "./AlertsPanel";
import {hasDateFilters} from "../utils/filters";
import {fetchProfitDriversAnalysis} from "../utils/profitDrivers";

export const DashboardContainer = () => {
    const {filters, navOptions, handleNavigate} = useOutletContext();
    const navigate = useNavigate();
    const [profitDriversData, setProfitDriversData] = useState(null);

    const fetchAuditProfile = useCallback(() => {
        if (!hasDateFilters(filters)) {
            return;
        }

        fetchProfitDriversAnalysis(filters, (data) => {
            setProfitDriversData(data);
        });
    }, [filters]);

    useEffect(() => {
        fetchAuditProfile();
    }, [fetchAuditProfile]);
    // Store each panel's selected kpis
    const [selectedKpis, setSelectedKpis] = useState({
        panel1: 'net_revenue',
        panel2: 'pocket_price_margin', 
        panel3: 'pocket_price_margin_per_unit'
    });

    const handleKpiClick = (panelId) => {
        const currentKpi = selectedKpis[panelId];
        handleNavigate(navOptions.reports.subMenu.reportsKPI);
        navigate(`/reports/kpi?kpi=${currentKpi}`);
    };

    const handleKpiChange = (panelId, newKpiType) => {
        setSelectedKpis(prev => ({
            ...prev,
            [panelId]: newKpiType
        }));
    };

    return (
        <div style={{marginTop: 30, marginBottom: 100}}>
            <Grid container justifySelf="center" spacing={2}>
                <Grid size={4} justifyItems="center">
                    <MeasurePanel 
                        filters={filters} 
                        initialType="net_revenue"
                        onHeaderClick={() => handleKpiClick('panel1')}
                        onKpiChange={(kpiType) => handleKpiChange('panel1', kpiType)}
                    />
                </Grid>
                <Grid size={4} justifyItems="center">
                    <MeasurePanel 
                        filters={filters} 
                        initialType="pocket_price_margin"
                        onHeaderClick={() => handleKpiClick('panel2')}
                        onKpiChange={(kpiType) => handleKpiChange('panel2', kpiType)}
                    />
                </Grid>
                <Grid size={4} justifyItems="center">
                    <MeasurePanel 
                        filters={filters} 
                        initialType="pocket_price_margin_per_unit"
                        onHeaderClick={() => handleKpiClick('panel3')}
                        onKpiChange={(kpiType) => handleKpiChange('panel3', kpiType)}
                    />
                </Grid>
                <Grid size={4} justifyItems="center">
                    <ProfitDriversPanel minimal data={profitDriversData} />
                </Grid>
                <Grid size={4} justifyItems="center">
                    <ProfitLeaksPanel minimal/>
                </Grid>
                <Grid size={4} justifyItems="center">
                    <AlertsPanel minimal/>
                </Grid>
            </Grid>
        </div>
    );
};